import React from 'react';

const Header = ({title}) => (
  <div className="packSelect-header">
    <h1 className="packSelect-header-title">
      {title}<span>.</span>
    </h1>
    <h2 className="packSelect-header-subtitle">
      Choisissez votre pack, nous gérons ensuite toutes les démarches
    </h2>
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/buy/table-checkouts/PackSelectorPage/Header.js